import { theme } from "../../../../../../../../theme";

export default function BTeileBarSVG2(props) {
  const fontFamily = theme.typography.fontFamily;
  return (
    <svg
      {...props}
      viewBox="0 0 778 907"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="temp 2">
        <text
          fill="black"
          xmlSpace="preserve"
          style="white-space: pre"
          fontFamily={fontFamily}
          fontSize="73"
        >
          <tspan x="113.266" y="701.28">
            15 %
          </tspan>
        </text>
        <rect id="rectangle" y="757" width="389" height="150" fill="#E20031" />
        <rect
          className="gsap-bar"
          x="389"
          y="658"
          width="389"
          height="249"
          fill="#4A4949"
        />
      </g>
    </svg>
  );
}
